import type { JSX } from 'react';
import { errorText, useLang } from '../i18n/index.js';
import { useApp } from '../state/store.js';
import { Icon, type IconName } from './Icon.js';
import './Toast.css';

/**
 * Transient feedback. Errors say what happened and what to do next (§12); the
 * store owns the text and the dismiss timer, this only renders it.
 */

const TONE_ICON: Record<'info' | 'warn' | 'win', IconName> = {
  info: 'signal',
  warn: 'responsible',
  win: 'chip',
};

export function Toast(): JSX.Element | null {
  const toast = useApp((s) => s.toast);
  const lang = useLang();
  if (toast === null) return null;

  const text = errorText(toast.code, toast.text, lang);

  return (
    <div className={`toast toast--${toast.tone}`} role="status" aria-live="polite">
      <div className="toast__inner">
        <span className="toast__stripe" aria-hidden="true" />
        <Icon name={TONE_ICON[toast.tone]} size={16} className="toast__icon" />
        {text}
      </div>
    </div>
  );
}
